import Vue from 'vue';


export default Vue.extend({

  props: {
    resultdata :[]
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: 'Student Name',
          align: 'start',
          sortable: false,
          value: 'Student_Name',
        },
        { text: 'Last Test Taken', value: 'Date' },
        { text: 'Average', value: 'Average' },
        { text: 'Percentile Score', value: 'Score' },
      ],
      Students: [
        {
          Student_Name: 'Walter Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'Yalter Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'xalter Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'alter Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'dalter Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'ralter Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'qalter Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'xalter Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'lter Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'ter Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'W B',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'Y B',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
        {
          Student_Name: 'W Brown',
          Date: '04 Apr,2020',
          Average: '85%',
          Score: '85',
        },
        {
          Student_Name: 'Y Brown',
          Date: '03 Apr,2020',
          Average: '85%',
          Score: '89',
        },
      ],
      
    }
  },
  created() {
    console.log("reejh",this.resultdata) ;
  }
   
  })